import { useCallback } from 'react'

import { SelectBaseProps } from 'govwell-ui/components/Select/types'

import { FormulaOutputUserType, UserDataFragment } from '../../../../types/graphql'
import { SelectFieldProps } from '../../../utils/forms'
import StaffUserSelect from '../../Selects/StaffUserSelect'

type Props<TKey extends string> = Omit<
  SelectBaseProps<UserDataFragment>,
  'getOptionKey' | 'options'
> & {
  type: FormulaOutputUserType
} & SelectFieldProps<UserDataFragment, TKey>
const StaffUserSelectField = <TKey extends string>({
  field,
  filterOption,
  isDisabled,
  isMultiSelect,
  isRequired,
  onValueChange,
  label,
  type,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  const handleMultipleValueChange = useCallback(
    (value: UserDataFragment[] | undefined) => {
      if (isMultiSelect) {
        field.setValue(value ?? [])
        onValueChange?.(value ?? [])
      }
    },
    [field, isMultiSelect, onValueChange]
  )

  const handleSingleValueChange = useCallback(
    (value: UserDataFragment | null | undefined) => {
      if (!isMultiSelect) {
        field.setValue(value)
        onValueChange?.(value)
      }
    },
    [field, isMultiSelect, onValueChange]
  )

  const commonProps = {
    errorMessage,
    filterOption,
    isDisabled,
    isInvalid: !!errorMessage,
    isRequired: isRequired,
    onBlur: field.handleBlur,
    label: label,
    type: type,
  }

  if (isMultiSelect) {
    return (
      <StaffUserSelect
        isMultiSelect
        onValueChange={handleMultipleValueChange}
        value={field.state.value}
        {...commonProps}
      />
    )
  }
  return (
    <StaffUserSelect
      isMultiSelect={false}
      onValueChange={handleSingleValueChange}
      value={field.state.value}
      {...commonProps}
    />
  )
}

export default StaffUserSelectField
